<template>
	<ul
		class="calculator__graphlegend"
		:class="`calculator__graphlegend--${level === -1 ? 'root' : `l${level}`}`"
	>
		<li
			v-for="share in shares"
			:key="share.key"
			class="calculator__graphlegend-item"
			:class="`calculator__graphlegend-item--${share.key} calculator__graphlegend-item--${
				level === -1 ? 'root' : `l${level}`
			}`"
		>
			<div
				class="calculator__graphlegend-item-wrapper"
				:class="{
					'calculator__graphlegend-item-wrapper--parent': !!share.parts,
					'calculator__graphlegend-item-wrapper--deceased': share.isDeceased
				}"
			>
				<span
					:style="{ background: share.color }"
					class="calculator__graphlegend-item-color"
					:class="{
						'calculator__graphlegend-item-color--absolute': share.isAbsolute
					}"
				></span>

				<span class="calculator__graphlegend-item-value">
					<span v-if="!share.isAbsolute" class="calculator__graphlegend-item-percentage">
						{{ share.value }}%
					</span>

					{{ share.title
					}}<span v-if="share.absoluteValue"
						>: CHF {{ formatNumber(share.absoluteValue) }}.-
					</span>
				</span>
			</div>

			<GraphLegend v-if="share.parts" :shares="share.parts" :level="level + 1" />
		</li>
	</ul>
</template>

<script>
import { formatNumber } from '../utils/helpers';

export default {
	name: 'GraphLegend',
	props: {
		shares: Array,
		groupKey: String,
		level: {
			type: Number,
			default: -1
		}
	},
	methods: {
		formatNumber
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__graphlegend {
	min-width: 0;
	list-style: none;
	margin: 0 0 0 1.5em;
	padding: 0;
	font-size: 0.9em;
	min-width: 12rem;
}
.calculator__graphlegend--root {
	margin-left: 0;
}

.calculator__graphlegend-item {
	margin-top: 1em;
}
.calculator__graphlegend-item--root:first-child {
	margin-top: 0;
}
.calculator__graphlegend-item--free {
	color: rgba(0, 0, 0, 0.5);
}

.calculator__graphlegend-item-wrapper {
	display: flex;
	border-bottom: 1px solid black;
	align-items: flex-end;
}
.calculator__graphlegend-item-wrapper--parent {
	color: rgba(0, 0, 0, 0.5);
}
.calculator__graphlegend-item-wrapper--deceased {
	color: rgba(0, 0, 0, 0.5);
	text-decoration: line-through;
}

.calculator__graphlegend-item-color {
	display: block;
	width: 1.5em;
	height: 1.5em;
	margin-right: 0.5em;
	flex-shrink: 0;
}
.calculator__graphlegend-item-color--absolute {
	visibility: hidden;
}

.calculator__graphlegend-item-value {
	margin-bottom: 0.2em;
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	max-width: calc(100% - 2em);
}
</style>
